import { IAccount, IShift, ShiftService, EmployeesService, AccountsService, LocationService, Masterdata, ITeam } from "../../services/index";
import * as moment from "moment";

class CheckAvailabilityModalController implements ng.IComponentController {
    private shifts: IShift[];
    private shift: IShift;
    private accounts: IAccount[];
    private functions: Masterdata[];
    private locations: any;
    private teams: ITeam[];
    private employees: any;
    private accountNotes: any;
    private selectedEmployee: any;
    private activeEmployee: any;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private AccountsService: AccountsService,
        private MasterdataService: aboMasterdata.IService,
        private LocationService: LocationService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private $window : ng.IWindowService
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.MasterdataService.getItems('Functions').then((result) => {
            this.functions = result;
        });

        this.AccountsService.all().then((result) => {
            this.accounts = result;
        });  

        this.selectedEmployee = {};
        this.activeEmployee = {};  
        
        this.setModalHeight();
       
        this.$window.onresize = (event) => {
            this.setModalHeight();
        }
    }

    private setModalHeight = () => {
        var docHeight = $(window).height();
        var height = docHeight - 200;
        $("#checkAvailabilityModalBody").height(height);
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    startDateChanged() {
        this.shift.end = moment(this.shift.start).add(8, 'hour').toDate();
        if (this.shift.teamLocationId) {
            this.dataFilledIn();
        }
    }

    endDateChanged() {
        if (this.shift.teamLocationId) {
            this.dataFilledIn();
        }
    }

    dataFilledIn() {
        if (this.shift.start && this.shift.end) {
            var request = {
                accountId: this.shift.teamLocationAccountId,
                locationId: this.shift.teamLocationId,
                startDate: this.shift.start,
                endDate: this.shift.end,
                shiftId: this.shift.id
            };

            this.EmployeesService.customPost('availableEmployees', request, false).then((result) => {
                this.employees = result;
            });
        }
    }

    selectedAccount() {
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
            this.locations = result;
        });

        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'notes/?tag=planning').then((result) => {
            this.accountNotes = result;
        });
    }

    locationSelected() {
        this.teams = this.locations.find(item => item.id === this.shift.teamLocationId).teams;
        this.dataFilledIn();
    }

    submitShift(after = null) {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.employeeId) {
            this.shift.status = 5;
        } else {
            this.shift.status = 3;
        }
        
        if (!this.shift.id) {
            this.ShiftService.post(this.shift).then((data) => {
                this.shift = data;

                this.shifts.push(this.shift);
                this.closeModal();
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.shift = data;

                this.shifts = this.shifts.filter(s => s.id !== this.shift.id);
                this.shifts.push(this.shift);
                this.closeModal();
            });
        }
    }

    closeModal() {
        this.selectedEmployee = {};
        this.activeEmployee = {};
        this.employees = null;
        this.shift = new IShift();
        (<any>$('#check-availability-modal')).modal('hide');
    }
}

export const checkAvailabilityModalComponent: ng.IComponentOptions = {
    controller: CheckAvailabilityModalController,
    bindings: {
        shifts: '=',
        shift: '=',
        locations: '=',
        teams: '=',
        accountNotes: '=',
        employees: '=',
        selectedEmployee: '='
    },
    template: <string>require('./checkAvailabilityModal.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/checkAvailabilityModal.component.ts